document.addEventListener("DOMContentLoaded", () => {
  console.log("🔥 Script Loaded - Simplified Megamenu + Mobile Menu");

  // 🔧 Mobile Menu Toggle
  function initMobileMenu() {
    const mobileMenuToggle = document.querySelector(".mobile-menu-toggle-left");
    const mobileMenu = document.querySelector(".mobile-menu");
    const closeButton = document.querySelector(".toggle-close-button");

    if (!mobileMenuToggle || !mobileMenu) return;

    mobileMenuToggle.addEventListener("click", () => {
      mobileMenu.classList.toggle("open");
    });

    if (closeButton) {
      closeButton.addEventListener("click", () => {
        mobileMenu.classList.remove("open");
      });
    }
  }

  // 🔧 Mobile Dropdown Toggles
  function initMobileDropdowns() {
    const dropdownButtons = document.querySelectorAll(".dropdown-btn");

    dropdownButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        btn.classList.toggle("active");
        const content = btn.nextElementSibling;
        if (content) {
          content.style.display = content.style.display === "block" ? "none" : "block";
        }
      });
    });
  }

  // 🔧 Desktop Megamenu Interactions
  function initMegaMenu() {
    const categories = document.querySelectorAll(".bt-category");
    const bodyPartsSections = document.querySelectorAll(".bt-bodyparts");
    const braceLists = document.querySelectorAll(".bt-bodyparts-bracename");
    const images = document.querySelectorAll(".bt-megamenu-img img");
    const yellowColumn = document.querySelector(".bt-column-braces");
// Reset to default on Shop hover
const shopMenuTrigger = document.querySelector(".bt-nav__item--has-dropdown");

if (shopMenuTrigger) {
  shopMenuTrigger.addEventListener("mouseenter", () => {
    categories.forEach((c) => c.classList.remove("active"));
    const defaultCategory = document.querySelector('.bt-category[data-section="canine"]');
    if (defaultCategory) {
      defaultCategory.classList.add("active");
      showBodyParts("canine");
    }
  });
}

    function resetSections() {
      bodyPartsSections.forEach((bp) => (bp.style.display = "none"));
      braceLists.forEach((bl) => (bl.style.display = "none"));
      images.forEach((img) => img.classList.remove("active"));
      document.querySelectorAll(".bt-bodyparts li").forEach((li) => li.classList.remove("active"));
      yellowColumn.innerHTML = "";
      yellowColumn.style.display = "none";
    }

function showBraces(bodyPart) {
  if (!bodyPart || typeof bodyPart !== "string") return;
  const part = bodyPart.trim().toLowerCase();
      const selectedBraces = [...braceLists].find(
        (el) => el.getAttribute("data-bodypart").trim().toLowerCase() === part
      );
      if (selectedBraces) {
        const clone = selectedBraces.cloneNode(true);
        clone.style.display = "block";
        yellowColumn.innerHTML = "";
        yellowColumn.appendChild(clone);
        yellowColumn.style.display = "block";
      } else {
        yellowColumn.style.display = "none";
      }
    }

function highlightImage(bodyPart) {
  if (!bodyPart || typeof bodyPart !== "string") return;
  images.forEach((img) => img.classList.remove("active"));
  const img = document.querySelector(`.bt-megamenu-img img[data-bodypart="${bodyPart}"]`);
  if (img) img.classList.add("active");
}


function showBodyParts(section) {
  resetSections();
  const list = document.querySelector(`.bt-bodyparts[data-section="${section}"]`);
  if (list) list.style.display = "flex";

  let defaultBody = list?.querySelector("li[data-bodypart]")?.getAttribute("data-bodypart");

  // ✅ Hardcode fallback for "learn"
  if (!defaultBody && section === "learn") {
    defaultBody = "learn";
  }

  if (defaultBody) {
    const liToActivate = list.querySelector(`li[data-bodypart="${defaultBody}"]`);
    if (liToActivate) liToActivate.classList.add("active");
    showBraces(defaultBody);
    highlightImage(defaultBody);
  }
}



    categories.forEach((cat) => {
      cat.addEventListener("click", (e) => {
        e.preventDefault();
        categories.forEach((c) => c.classList.remove("active"));
        cat.classList.add("active");
        showBodyParts(cat.getAttribute("data-section"));
      });
    });

    document.querySelectorAll(".bt-bodyparts li").forEach((li) => {
      li.addEventListener("mouseenter", () => {
        document.querySelectorAll(".bt-bodyparts li").forEach((el) => el.classList.remove("active"));
        li.classList.add("active");
        const bodyPart = li.getAttribute("data-bodypart");
        showBraces(bodyPart);
        highlightImage(bodyPart);
      });
    });
  }

  // 🔧 Sticky Header
const header = document.querySelector(".desktop-menu");
if (header) {
  window.addEventListener("scroll", () => {
    if (window.scrollY > 0) {
      header.classList.add("sticky-header");
      document.body.style.paddingTop = `${header.offsetHeight}px`;
    } else {
      header.classList.remove("sticky-header");
      document.body.style.paddingTop = "0";
    }
  });
}

  // 🔧 Init all
  initMobileMenu();
  initMobileDropdowns();
  initMegaMenu();
});
